<template>
  <div class="q-w360 q-fit">
    <question-with-error-wrap :error="getFieldsError(['proneToAcne'])">
      <single-answer-question
        title="label.proneToAcne"
        :value="proneToAcne"
        :options="$options.yesNoResponseOptions"
        dysfunction="pimples"
        yes-no
        @input="onFieldChange('proneToAcne', $event)"
      />
    </question-with-error-wrap>
  </div>
</template>

<script>
import QuestionWithErrorWrap from '@/modules/questionnaire/new-design-components/questions/QuestionWithErrorWrap';
import SingleAnswerQuestion from '@/modules/questionnaire/new-design-components/questions/SingleAnswerQuestion';

import { stepTemplateMixin } from '@/modules/questionnaire/mixins/stepTemplateMixin';

import { YES_NO_RESPONSE_OPTIONS } from '@/modules/questionnaire/constants/questions';

export default {
  name: 'PimplesTemplate',
  components: { QuestionWithErrorWrap, SingleAnswerQuestion },
  yesNoResponseOptions: YES_NO_RESPONSE_OPTIONS,
  mixins: [stepTemplateMixin],
  props: {
    proneToAcne: {
      type: String,
      default: ''
    }
  }
};
</script>
